module.exports = __webpack_public_path__ + "static/media/phone.0abcf2a3.svg";